import React from "react";
import {
  Box,
  Dialog,
  Button,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ModalViewerPdf = ({ onClose, urlBlob }) => {
  return (
    <div>
      <DialogTitle>
        Detalles de la guía
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", height: 500 }}>
          <embed
            src={urlBlob}
            type="application/pdf"
            width="100%"
            height="600px"
          />
        </Box>
      </DialogContent>
      <DialogActions variant="paddi">
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </div>
  );
};

export default ModalViewerPdf;
